import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { AssignPosValidationSchema } from "../pages/Show/schemas/assignPos.schema"

interface UseAssignPosModalProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useAssignPos = ({ id, onSuccess, onError }: UseAssignPosModalProps) => {
  const privateAxios = usePrivateAxios()
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['assignPos', id],
    mutationFn: async (data: AssignPosValidationSchema) => {
      await privateAxios.put(`/pos/machines/${id}/assign`, {
        pos: {
          establishment_company_branch_id: data.establishment_branch.value,
          assign_reason: data.description
        }
      })
    },
    onSuccess: () => {
      if (id) {
        queryClient.invalidateQueries({queryKey: ["posMachineById", id]});
      }
      onSuccess?.();
    },
    onError,
  })
}